/* eslint-disable react-hooks/exhaustive-deps */
import { ActionButton, PermissionLink } from 'components';
import moment from 'moment';
import { ModalDelete } from 'pages/Sales/Transaction/CustomerOrder/components';
import { Fragment } from 'react';
import { IoSendSharp } from 'react-icons/io5';
import { useToggle } from 'utils';
import { RegisterDateType } from '../types';
import { APPROVAL } from '../utils/vars';
import { permissionProps } from 'types';
import { default_option } from 'pages/Purchase/utils';
import { delivery_option } from 'pages/Purchase/Register/utils';
import { PERMISION } from 'security';

interface ItemProps {
  index: number;
  item: RegisterDateType;
  onDeleteSucces?: () => void;
  permission: permissionProps
}

export function Item({ index, item, onDeleteSucces, permission }: ItemProps) {
  const modalDelete = useToggle(false);

  return (
    <Fragment>
      <tr key={item.sales_order_id}>
        <td>{index + 1}</td>
        <td className="font-normal">
          <span className="ps-4"></span>
          {item.trx_code}
        </td>
        <td>{moment(item.transaction_date).format('DD/MM/YYYY')}</td>
        <td>{item.customer_name}</td>
        <td>{default_option.find(opt => opt.value === String(item.approval_status))?.label ?? "-"}</td>
        <td>{delivery_option.find(opt => opt.value === String(item.so_delivery_status))?.label ?? "-"}</td>
        <td className="text-center">{item.qty_order.toLocaleString('id-ID')}</td>
        <td className="text-center">{item.qty_delivered.toLocaleString('id-ID')}</td>
        <td className="text-center">{item.qty_back_order.toLocaleString('id-ID')}</td>
        <td className="text-right">{item.total.toLocaleString()}</td>
        <td className="text-right">{item.total_payment.toLocaleString()}</td>
        <td className="text-right">{item.balance_owing.toLocaleString()}</td>
        <td className="cursor-pointer">
          <div className="flex items-center gap-2">
            <PermissionLink
              permission={PERMISION.SALES.REGISTER.BY_DATE_RANGE.UPDATE}
              className='mt-2'
              to={`/sales/transaction/customer-order/edit/${item.sales_order_id}`}
            >
              <button color="primary" className="rounded-full" title="Collapse">
                <IoSendSharp size={15} />
              </button>
            </PermissionLink>
            {item.approval_status === APPROVAL.PENDING ? (
              <ActionButton.Delete permission={PERMISION.SALES.REGISTER.BY_DATE_RANGE.DELETE} color='red' onClick={modalDelete.toggle} />
            ) : null}
          </div>
        </td>
      </tr>

      <ModalDelete
        data={item}
        modalState={modalDelete}
        onSuccess={onDeleteSucces}
      />
    </Fragment>
  );
}
